import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";

import { Table } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import useFetchItems from "../../hooks/useFetchItems";
import { recoveryPlanCols } from "./AllColumnsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useChangeHandler from "../../hooks/useChangeHandler";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const MODULE_NAMES = ["Recovery Plan", "Restoration Services","Insurance Claim Procedures","Contractor Contacts"];
export default function RecoveryPlan() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Recovery Plan");
  const [formData, setFormData] = useState(null);
  const history = useHistory();
  const [attributesData, setAttributesData] = useState(null);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(MODULE_NAMES, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading);
  const { attributes, disasterAttribute } = useGetAttributes(MODULE_NAMES, setLoading);
  console.log("attributessss", attributes);

  const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setFormData,
    setAttributesData
  );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const AddInsurance = () => {
    history.push("/insurance_new");
  };
  const AddContact = () => {
    history.push("/client/plan");
  };

  const collapseableTables = [
    { title: "Insurance Claim Procedures", key: 1 },
    { title: "Contractor Contacts", key: 2 },
    { title: "Restoration Services", key: 3 },
  ];
  const tableDataObj = {
    "Restoration Services": tableData.restorationServicesData,
    "Insurance Claim Procedures":tableData.insuranceClaimProceduresData,
    "Contractor Contacts": tableData.contractorContactsData,
  };
  const AllColumnsData = recoveryPlanCols(viewModal, updateModal, deleteRecord);
  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Recovery Plan</h2>
        <ToolTipCreator name={"Disaster_Recovery_Plan"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      {collapseableTables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          onClick={() => (table.title === "Restoration Services" , "Insurance Claim Procedures", "Contractor Contacts"? showModal(table.title) : AddContact())}
        >
          <Table columns={AllColumnsData[table.title]} dataSource={tableDataObj[table.title]} />
        </CollapseableTable>
      ))}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute && disasterAttribute}
            values={disasterAttributeData && disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
}
